import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Paper, Stack, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import Modal from '../../../components/Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const SignupFailedModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} handleClose={onClose}>
      <Paper sx={{ padding: '24px', maxHeight: "100vh", overflowY: "auto" }}>
        <Stack width="100%" alignItems="flex-end">
          <IconButton sx={{ padding: 0 }} onClick={onClose}>
            <CancelIcon fontSize="medium" sx={{ color: '#282032' }} />
          </IconButton>
        </Stack>

        <Stack gap="16px" direction="column" alignItems="center" justifyContent="center">
          <Stack padding="24px 0px">
            <CancelIcon sx={{ fontSize: 88, color: '#CF1E3C' }} />
          </Stack>
          <Typography variant="body1" color="primary" fontWeight={700} textAlign="center">
            {t('signup_status_process.failure')}
          </Typography>
          <Typography color="secondary.light" padding="0px 20px" variant="body2" textAlign="center" fontWeight={500}>
            {t('signup_status_process.failure_description')}
          </Typography>
        </Stack>
      </Paper>
    </Modal>
  );
};
